import axiosClient from "../axioxClient.ts/axiosClient";
import { ILoginResponse, IOTPResponse, IUserDetails } from "../exports/interfaces";
import { dynamicFailed } from "../hooks/useToast";

export const fetchProfile = async () => {
  try {
    const res = await axiosClient.get<any>("/users/me");
    return res.data;
  } catch (error: any) {
    // const message = error?.response?.data?.message || "Something went wrong!";
    // dynamicFailed(message);
  }
};

export const login = async (email: string, password: string) => {
  const res = await axiosClient.post<ILoginResponse>("/auth/login", {
    email,
    password,
  });
  return res;
};

export const logout = async () => {
  await axiosClient.post("/auth/logout");
};

export const requestOtp = async (email: string) => {
  const res = await axiosClient.post<IOTPResponse>("/otp/request", {
    email,
  });
  return res.data;
};

export const otpVerify = async (email: string, otp: number) => {
  const res = await axiosClient.post<IOTPResponse>("/otp/verify", {
    email,
    otp,
  });
  return res.data;
};

export const resetPassword = async (
  email: string,
  password: string,
  confirmPassword: string,
) => {
  const res = await axiosClient.post<IOTPResponse>("/auth/password-reset", {
    email,
    password,
    confirmPassword,
  });
  return res.data;
};

export const fetchUsers = async (): Promise<IUserDetails[]> => {
  try {
    const response = await axiosClient.get<IUserDetails[]>("/users");
    return response.data;
  } catch (error: any) {
    const message = error?.response?.data?.message || "Something went wrong!";
    dynamicFailed(message);
    return [];
  }
};
